import * as vp from 'vopay';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';

const apiConfig = vp.VoPayApi(apiBaseUrl);

export const api = apiConfig.api;

export default apiConfig;
